/**
 * The process* lambdas answer a rejected write with
 * `{ error: { message, userFacing } }`. Most of what they throw is a defect or a
 * raw AWS message and belongs behind the client's generic notice; a few are
 * written for the person who hit them — the shipment moved out from under the
 * form, the slot went while it was open — and name both the problem and the way
 * forward. `userFacing` is how the lambda says which is which.
 *
 * The flag exists so the client never has to match on the copy: wording changes
 * would otherwise break this silently, and only in the failure path where
 * nobody is looking.
 *
 * @param {unknown} error - whatever reached a catch or an onFailure handler
 * @returns {boolean} true when the message can be shown verbatim
 */
export const isUserFacingError = (error) =>
  error?.userFacing === true && Boolean(error.message);
